<template>
  <div>
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="addEditModal"
        persistent
        max-width="500px"
      >
        <v-card>
          <form @submit.prevent="submitForm()">
            <v-card-title class="pb-0">
              <v-flex
                xs11
                sm10
                md10
              >
                <span class="headline">
                  {{ isUpdate ? $t('mobileApp.updateOurAddressTitle') : $t('mobileApp.addNewOurAddressTitle') }}
                </span>
              </v-flex>
              <v-flex
                xs1
                sm2
                md2
              >
                <v-btn
                  flat
                  @click="closeDialog()"
                  class="close"
                >
                  <span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-layout wrap>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-select
                    :items="warehouses"
                    item-value="value"
                    v-model="form.warehouse_id_fk"
                    :error-messages="errors.collect('warehouse_id_fk')"
                    data-vv-name="warehouse_id_fk"
                    :label="$t('columns.warehouse') + '*'"
                    v-validate="'required'"
                    @input="handleSelectWarehouse(form.warehouse_id_fk)"
                  >
                  </v-select>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-select
                    :items="transportationTypes"
                    item-value="id"
                    item-text="name"
                    v-model="form.transportation_type"
                    :error-messages="errors.collect('Transportation Type')"
                    data-vv-name="Transportation Type"
                    :label="$t('columns.transportationType') + '*'"
                    v-validate="'required'"
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    :label="$t('columns.title') + ' *'"
                    v-model="form.title"
                    :error-messages="errors.collect('Title')"
                    v-validate="'required'"
                    data-vv-name="Title"
                  />
                </v-flex>

                <v-flex xs12>
                  <label
                    for="description"
                    style="opacity: 0.8; font-size: 14px; margin-bottom: -8px"
                  >
                    {{ $t('columns.description') }}
                  </label>
                  <textarea
                    v-model="form.description"
                    class="form-control"
                    style="border-bottom: 1px solid blue; font-size: 1.5rem"
                    rows="4"
                  />
                </v-flex>

                <v-flex xs12>
                  <label
                    for="note"
                    style="opacity: 0.8; font-size: 14px; margin-bottom: -8px"
                  >
                    {{ $t('columns.note') }}
                  </label>
                  <textarea
                    v-model="form.note"
                    class="form-control"
                    style="border-bottom: 1px solid blue; font-size: 1.5rem"
                    rows="4"
                  />
                </v-flex>
              </v-layout>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                style="height:auto"
                @click="closeDialog()"
                outline
                color="normal"
              >{{ $t('common.cancel') }}</v-btn>
              <v-btn
                type="submit"
                :loading="loading"
                style="height:auto" class="submit-btn-spacing"
                outline
                color="success"
              >
                {{ isUpdate ? $t('common.save') : $t('common.add') }}
              </v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import Axios from 'axios'
import swal from 'sweetalert'

export default {
  props: ['addEditModal', 'form', 'isUpdate', 'warehouses'],

  data() {
    return {
      loading: false,
      transportationTypes: []
    }
  },

  watch: {
    addEditModal: {
      immediate: false,
      handler() {
        if (this.isUpdate) {
          const warehouse = this.warehouses.find(w => w.value === this.form.warehouse_id_fk)

          if (warehouse) {
            this.transportationTypes = warehouse.transportation_types
          }
        }
      }
    }
  },

  methods: {
    closeDialog() {
      this.$validator.reset()
      this.$emit('close')
    },

    handleSelectWarehouse(id) {
      this.form.transportation_type = null
      const warehouse = this.warehouses.find(w => w.value === id)

      if (warehouse) {
        this.transportationTypes = warehouse.transportation_types
      }
    },

    submitForm() {
      let token = localStorage.getItem('access_token')

      this.$validator.validateAll().then((res) => {
        if (res) {
          this.loading = true

          if (this.isUpdate) {
            Axios.put(`api/our-address/${this.form.our_address_id}`, this.form, {
              headers: { Authorization: 'Bearer ' + token }
            })
              .then(() => {
                this.loading = false
                swal({
                  title: this.$t('common.updatedSuccessfully'),
                  text: '',
                  icon: 'success',
                  timer: 1500,
                  buttons: false
                })
                this.$emit('resetTable')
                this.closeDialog()
              })
              .catch((error) => {
                this.loading = false
                swal(this.$t('common.error'), error.response.data.message, 'error')
              })
          } else {
            Axios.post('api/our-address', this.form, {
              headers: { Authorization: 'Bearer ' + token }
            })
              .then(() => {
                this.loading = false
                swal({
                  title: this.$t('common.addedSuccessfully'),
                  text: '',
                  icon: 'success',
                  timer: 1500,
                  buttons: false
                })
                this.$emit('resetTable')
                this.closeDialog()
              })
              .catch((error) => {
                this.loading = false
                swal(this.$t('common.error'), error.response.data.message, 'error')
              })
          }
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}

.image-upload-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.image-upload {
  border: 1px dashed #ccc;
  cursor: pointer;
  position: relative;
  background-position: center;
  background-size: cover;
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/ourAddress/addEdit.vue